import { Model } from "@/models";

export default class IndicatorFilter extends Model {
  static type = "indicatorFilters";
  organizationRegions: string[];
  organizationCategories: string[];
  initiativeSteps: string[];
  organizationTypes: string[];
}
